import React from "react";

export const LazyCasesCountBarChart = React.lazy(() =>
    import(
        /* webpackChunkName: "CasesCountBarChart" */ "./CasesCountBarChart"
    ).then(x => ({ default: x.CasesCountBarChart }))
);
